(() => {
  if (window.SwaglabCompactDesktopMenuReady) return;
  window.SwaglabCompactDesktopMenuReady = true;

  const desktopQuery = window.matchMedia('(min-width: 750px)');
  let activeTrigger = null;

  const getPanel = () => document.querySelector('[data-swaglab-desktop-menu]');
  const getHeader = () => document.querySelector('#header-component') || document.querySelector('header');
  const getOpeners = () => document.querySelectorAll(
    '[data-swaglab-desktop-menu-open], [data-swaglab-open-main-menu]'
  );

  const setExpanded = (expanded) => {
    getOpeners().forEach((trigger) => trigger.setAttribute('aria-expanded', String(expanded)));
  };

  const positionPanel = () => {
    const panel = getPanel();
    const header = getHeader();
    if (!panel || !header || panel.hidden) return;

    const rect = header.getBoundingClientRect();
    const top = Math.max(0, Math.round(rect.bottom + 7));
    const right = Math.max(16, Math.round(window.innerWidth - rect.right + 16));

    panel.style.setProperty('--swaglab-menu-top', `${top}px`);
    panel.style.setProperty('--swaglab-menu-right', `${right}px`);
  };

  const openMenu = (trigger) => {
    const panel = getPanel();
    if (!panel || !desktopQuery.matches) return false;

    activeTrigger = trigger || document.activeElement;
    panel.hidden = false;
    setExpanded(true);
    positionPanel();
    requestAnimationFrame(positionPanel);
    return true;
  };

  const closeMenu = ({ restoreFocus = false } = {}) => {
    const panel = getPanel();
    if (!panel || panel.hidden) return;

    panel.hidden = true;
    setExpanded(false);

    if (restoreFocus && activeTrigger?.isConnected) {
      activeTrigger.focus({ preventScroll: true });
    }

    activeTrigger = null;
  };

  const toggleMenu = (trigger) => {
    const panel = getPanel();
    if (!panel) return false;

    if (panel.hidden) return openMenu(trigger);
    closeMenu({ restoreFocus: false });
    return true;
  };

  document.addEventListener(
    'click',
    (event) => {
      const closeTrigger = event.target.closest?.('[data-swaglab-desktop-menu-close]');
      if (closeTrigger) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeMenu({ restoreFocus: true });
        return;
      }

      const openTrigger = event.target.closest?.(
        '[data-swaglab-desktop-menu-open], [data-swaglab-open-main-menu]'
      );

      if (!openTrigger || !desktopQuery.matches) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      toggleMenu(openTrigger);
    },
    true
  );

  document.addEventListener('click', (event) => {
    const panel = getPanel();
    if (!panel || panel.hidden) return;
    if (panel.contains(event.target)) return;
    if (event.target.closest?.('[data-swaglab-desktop-menu-open], [data-swaglab-open-main-menu]')) return;
    closeMenu({ restoreFocus: false });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const panel = getPanel();
    if (!panel || panel.hidden) return;
    event.preventDefault();
    closeMenu({ restoreFocus: true });
  });

  window.addEventListener('resize', positionPanel, { passive: true });
  window.addEventListener('scroll', positionPanel, { passive: true });

  const handleBreakpointChange = () => {
    if (!desktopQuery.matches) closeMenu({ restoreFocus: false });
  };

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', handleBreakpointChange);
  } else {
    desktopQuery.addListener(handleBreakpointChange);
  }
})();
